import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericApiService } from '@pm-ui/core-services';
import { Observable } from 'rxjs';
import { CompanyEndpoints } from '../../config/company/company-end-point';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private genericApiService: GenericApiService,private _http: HttpClient) { }

  getCompany<T>(reqModel:any): Observable<any>{     
    return this.genericApiService.post(CompanyEndpoints.GetCompany, reqModel);
   } 

  addUpdateCompany<T>(model: any): Observable<HttpResponse<T>> {
   return this.genericApiService.post(CompanyEndpoints.AddUpdateCompany, model);
  }
 
  deleteCompany<T>(companyId: number,siteId:number): Observable<HttpResponse<T>> {
    return this.genericApiService.delete(`${CompanyEndpoints.DeleteCompany}/${companyId}/${siteId}`);
   }

   CheckActiveCompanys<T>(companyId: number): Observable<HttpResponse<T>> {
    return this.genericApiService.delete(`${CompanyEndpoints.CheckActiveCompany}/${companyId}`);
   }
   
   getCompanyDropDown<T>(siteId:number,showAll:boolean,companyId:number): Observable<any>{  
    ///return this.genericApiService.get(CompanyEndpoints.GetCompanyBySiteId, siteId);
    return this.genericApiService.get<T>(`${CompanyEndpoints.GetCompanyBySiteId}/${siteId}/${showAll}/${companyId}`);   
  }
 
}
